/* eslint-disable react/jsx-props-no-spreading */
import React from "react"
import "./Footer.scss"

const Footer = ({ ...rest }) => {
  return <footer data-testid="footer" className="footer" {...rest} />
}

export default Footer
